import React, { useState } from 'react';
import FloatInput from 'components/generic-components/FloatInput';
import { CameraIconPlus, CloseModalIcon, PaymentIcon, FilledCardIcon, CardIcon, FiiledPaymentIcon, VisaLogo, MasterCardLogo, AmexLogo } from 'components/Icons';

import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';



const CardLogos = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();



    return (
        <div className="card-logos-wrapper">
            <VisaLogo />
            <MasterCardLogo />
            <AmexLogo />

        </div>
    );
};

export default CardLogos;
